<template>
  <v-dialog
    v-model="dialog"
    ref="dialog"
    max-width="920"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-form ref="form">
      <v-card elevation="0" class="checkout">
        <div class="checkout__bar">
          <div>
            <h2 class="checkout__title">Adicione seu cartão</h2>
            <p class="checkout__subtitle">
              Pagamento seguro • seus dados são tokenizados
            </p>
          </div>
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="checkout__body">
          <v-row dense>
            <!-- Preview do cartao -->
            <v-col
              cols="12"
              md="5"
              class="d-flex align-center justify-center checkout__preview"
            >
              <Card
                :isReadonly="true"
                :checkout="true"
                :data="localItem"
                ref="card"
              />
            </v-col>

            <!-- Formulario -->
            <v-col cols="12" md="7" class="checkout__form">
              <custom-masked-input
                v-model="localItem.maskedNumber"
                label="Número do cartão"
                placeholder="1234 5678 8765 4321"
                :currentValue="localItem.maskedNumber"
                :mask="'#### #### #### ####'"
              />
              <custom-input
                label="Nome no cartão"
                placeholder="John Doe"
                v-model="localItem.holder"
                :currentValue="localItem.holder"
              />
              <custom-masked-input
                label="CPF do titular"
                v-model="localItem.holderDoc"
                :currentValue="localItem.holderDoc"
                :mask="'###.###.###-##'"
                :customRule="rules.document"
              />
              <v-row dense align="center">
                <v-col cols="6" md="4">
                  <v-select
                    label="Mês"
                    :items="months"
                    v-model="localItem.expMonth"
                  ></v-select>
                </v-col>
                <v-col cols="6" md="4">
                  <v-select
                    label="Ano"
                    v-model="localItem.expYear"
                    :items="years"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <custom-masked-input
                    type="password"
                    label="CVV"
                    :mask="'###'"
                    v-model="localItem.cvv"
                  ></custom-masked-input>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="checkout__actions">
          <v-btn
            large
            rounded
            text
            color="primary-700"
            class="mr-2"
            @click="dialog = false"
          >
            <span style="text-transform: none">Cancelar</span>
          </v-btn>
          <v-btn
            large
            rounded
            class="checkout__save white--text"
            :loading="saving"
            :disabled="saving"
            @click="proceed"
          >
            <v-icon left>mdi-lock-check</v-icon>
            <span style="text-transform: none">Salvar cartão</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import Card from "./Card";
import { cpf } from "cpf-cnpj-validator";
import { tokenizeCard } from "@/shared/pagarme";
import customerApi from "@/shared/pitchCustomerApi";
export default {
  name: "CheckoutDialog",
  components: {
    Card,
  },
  mixins: [],
  props: {},
  data() {
    return {
      dialog: false,
      saving: false,
      localItem: {
        holder: "",
        maskedNumber: "",
        exp: "",
        cvv: "",
        expMonth: "",
        expYear: "",
        holderDoc: "",
      },
      months: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      years: [],
      rules: {
        document: [
          (v) => this.validateDocNumber(v) || "Número de documento inválido.",
        ],
      },
    };
  },
  mounted() {
    for (let year = 0; year <= 10; year++) {
      this.years.push(new Date().getFullYear() + year);
    }
  },
  watch: {
    // Vira o cartao para o verso enquanto o CVV esta sendo preenchido e volta
    // para a frente quando qualquer dado da frente muda.
    "localItem.cvv"(value) {
      if (value) this.showBack();
    },
    "localItem.maskedNumber"() {
      this.showFront();
    },
    "localItem.holder"() {
      this.showFront();
    },
    "localItem.expMonth"() {
      this.showFront();
    },
    "localItem.expYear"() {
      this.showFront();
    },
  },
  methods: {
    showBack() {
      if (this.$refs.card) this.$refs.card.setFlipped(true);
    },
    showFront() {
      if (this.$refs.card) this.$refs.card.setFlipped(false);
    },
    async proceed() {
      if (this.$refs.form && !this.$refs.form.validate()) return;

      this.saving = true;
      try {
        // Tokenize client-side: raw card data goes straight to pagar.me.
        const token = await tokenizeCard({
          number: this.localItem.maskedNumber,
          holderName: this.localItem.holder,
          expMonth: this.localItem.expMonth,
          expYear: this.localItem.expYear,
          cvv: this.localItem.cvv,
        });

        // Backend receives only the single-use token.
        const response = await customerApi.saveCard({
          token,
          holderDocument: (this.localItem.holderDoc || "").replace(/\D/g, ""),
        });

        this.$root.$emit("display-alert", {
          text: "Cartão cadastrado com sucesso!",
          type: 0,
        });
        this.$emit("saved", response.data || {});
        this.dialog = false;
      } catch (error) {
        const text =
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.message) ||
          (error && error.message) ||
          "Não foi possível cadastrar o cartão.";
        this.$root.$emit("display-alert", { text, type: 1 });
      } finally {
        this.saving = false;
      }
    },
    open() {
      this.dialog = true;
    },
    validateDocNumber(doc) {
      return cpf.isValid(doc);
    },
  },
};
</script>
<style scoped>
.checkout {
  border-radius: 20px;
  overflow: hidden;
  background: #ffffff;
}

.checkout__bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  color: #fff;
  background: linear-gradient(135deg, #ff5595 0%, #e8276f 55%, #8c1843 100%);
}

.checkout__title {
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  font-size: 1.35rem;
  line-height: 1.2;
}
.checkout__subtitle {
  margin: 2px 0 0;
  font-size: 0.78rem;
  opacity: 0.85;
}

.checkout__body {
  padding: 28px 24px 12px;
}

.checkout__preview {
  padding: 12px;
}

.checkout__form {
  padding: 0 8px;
}

.checkout__actions {
  padding: 8px 24px 22px;
  justify-content: flex-end;
}

.checkout__save {
  background: linear-gradient(135deg, #ff2b7a 0%, #b51f57 100%) !important;
  box-shadow: 0 8px 20px -6px rgba(181, 31, 87, 0.6);
  padding: 0 26px !important;
}
.checkout__save:hover {
  filter: brightness(1.05);
}

@media (max-width: 600px) {
  .checkout__preview {
    order: -1;
  }
}
</style>
